import { render, staticRenderFns } from "./Asignacionesv2tsp.vue?vue&type=template&id=2019dcfa"
import script from "./Asignacionesv2tsp.vue?vue&type=script&lang=js"
export * from "./Asignacionesv2tsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports